import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { ButtonStyled } from 'petco-ui/elements/button/Button.styled';

import { media, rem, themed } from '@/shared/ui/core';

const modifiers = {
  primary: ({ theme }) => ({
    styles: `
      font-weight: 600;
      font-size: 1.125rem;
      color: white;
      background-color: ${theme.primary.main};
      border: solid 1px ${theme.primary.main};
      border-radius: 0.25rem;

      &[disabled] {
        color: ${theme.disabled.text};
        background-color: ${theme.disabled.light};
        border-color: ${theme.disabled.light};
        opacity: 1;
      }
    `,
  }),
  secondary: ({ theme }) => ({
    styles: `
      font-size: 1.125rem;
      font-weight: 600;
      color: ${theme.primary.accent};
      background-color: ${theme.primary.background};
      border: 1px solid ${theme.primary.accent};
      justify-content: center;
    `,
  }),
  disabled: () => ({
    styles: `
      opacity: .4;
    `,
  }),
  textButton: ({ theme }) => ({
    styles: `
      background-color: unset;
      border: none;
      border-bottom-color: ${theme.primary.link};
      border-bottom-style: solid;
      border-bottom-width: ${rem(theme.button.text.borderWidth)};
      border-radius: 0;
      color: ${theme.primary.link};
      font-weight: 700;
      padding: ${theme.button.text.padding};
      height: auto;
      min-width: unset;
      width: unset;
    `,
  }),
};

const Button = styled(ButtonStyled)`
  padding: 0.125rem 0.25rem 0;
  font-family: ${themed('fontFamily')};

  svg {
    stroke-width: 1rem;
  }

  ${applyStyleModifiers(modifiers)};
`;

export const ButtonGroup = styled.div`
  margin: 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    font-size: 1rem;
    width: auto;
  }

  button + button {
    width: 50%;
  }

  @media ${media.tabletMin} {
    button + button {
      font-size: 0.9375rem;
      max-width: 13.625rem;
      height: 2rem;
      padding: 0.125rem 0.25rem 0;
      padding-bottom: 0.35rem;
    }
  }
`;

export default Button;
